module.exports = __webpack_public_path__ + "media/bootstrap-icons/telephone-forward-1b45ea51.svg";